"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = require("./Util");
var Endpoints_1 = require("../Utils/Endpoints");
var Services_1 = require("../Services");
var Components_1 = require("../Components");
var OfflineTemplateService = /** @class */ (function () {
    function OfflineTemplateService() {
    }
    OfflineTemplateService.check = function (selectedLocation) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    Util_1.getJson(Endpoints_1.default.CheckForTemplate, undefined, undefined, new Util_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: selectedLocation }))).then(function (response) {
                        resolve(response);
                    }).catch(function (e) {
                        reject(e);
                    });
                })];
        });
    }); };
    OfflineTemplateService.upload = function (e, resources, selectedLocation) {
        //console.log("OfflineTemplateService upload");
        //console.log(e);
        return new Promise(function (resolve, reject) {
            try {
                var files = e.target.files;
                if (!files || !files.length) {
                    //console.log("bad files");
                    //console.log(files)
                    reject({ cancel: true });
                    return;
                }
                if (!e.target.value.match(/(.vlx|.txt)+$/g)) {
                    reject(resources.Upload_WrongFormat);
                    return;
                }
                var file = files[0];
                var reader = new FileReader();
                var response_1;
                reader.onload = function (event) { return __awaiter(void 0, void 0, void 0, function () {
                    var fileBody;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                fileBody = event.target["result"];
                                return [4 /*yield*/, Util_1.getJson(Endpoints_1.default.UploadOfflineTemplate, {
                                        body: JSON.stringify(fileBody),
                                        credentials: "include",
                                        method: "post",
                                        headers: {
                                            "Accept": "application/json, application/xml, text/plain, text/html, *.*",
                                            "Content-Type": "application/json;"
                                        }
                                    }, undefined, new Util_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: selectedLocation })))];
                            case 1:
                                response_1 = _a.sent();
                                response_1 = JSON.parse(response_1);
                                response_1.Success ? resolve(response_1) :
                                    reject(Components_1.GetErrorMessageWithEmailLink(response_1.Message, response_1.Email)); //response.Email ? `${response.Message} <a href="mailto:${response.Email}">${response.Email}</a>` : response.Message);
                                return [2 /*return*/];
                        }
                    });
                }); };
                reader.readAsText(file);
                // Reset file input element so onChange event fires
                e.target.value = null;
            }
            catch (ex) {
                console.error("Error: " + ex);
                e.target.value = null;
            }
        });
    };
    OfflineTemplateService.download = function (selectedLocation) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", Endpoints_1.default.DownloadOfflineTemplate, true);
        var userRequestHeaders = new Util_1.UserRequestHeaders(Services_1.Auth.getUser());
        xhr.setRequestHeader(Util_1.UserRequestHeaders.OrganisationKey, userRequestHeaders.Organisation);
        xhr.setRequestHeader(Util_1.UserRequestHeaders.LocationKey, encodeURI(selectedLocation));
        xhr.setRequestHeader(Util_1.UserRequestHeaders.UserIdKey, userRequestHeaders.UserId);
        xhr.responseType = 'blob';
        xhr.onload = function (event) {
            var _a;
            var blob = this.response;
            var contentDispo = this.getResponseHeader('Content-Disposition');
            var match = (_a = contentDispo) === null || _a === void 0 ? void 0 : _a.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match) {
                var fileName = match[1];
                //console.log(fileName);
                fileName = fileName.startsWith('_') || fileName.startsWith('"') ? fileName.slice(1) : fileName;
                fileName = fileName.endsWith('_') || fileName.endsWith('"') ? fileName.slice(0, fileName.length - 1) : fileName;
                //console.log(saysWho());
                if (Util_1.saysWho().name == "IE") {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                }
                else {
                    var a = document.createElement('a');
                    a.href = window.URL.createObjectURL(blob);
                    a.download = fileName;
                    a.dispatchEvent(new MouseEvent('click'));
                }
            }
            else {
                console.error("invalid fileName");
                console.error(this.status);
                console.error(this.responseText || this.response);
            }
        };
        xhr.send();
    };
    return OfflineTemplateService;
}());
exports.OfflineTemplateService = OfflineTemplateService;
//# sourceMappingURL=OfflineTemplateService.js.map